import React, {Fragment} from "react";
import {connect} from "react-redux";
import {DEFAULT_PER_PAGE} from "../../config";
import {Button, Col, Row, Table, Tooltip} from "antd";
import {loadLogs} from "../../actions/account";
import {updatePage} from "../../actions/page";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {displayErrors} from "../../libs/utils";
import {DateTimeFormat} from "../shared/DateTimeFormat";

class Logs extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        logs: [],
        loadingLogs: true
    };

    componentDidMount() {
        this.props.updatePage('Logs');
        this.loadLogs();
    }

    loadLogs(page = null, per_page = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingLogs: true });

        this.props.loadLogs(page, per_page, null, (res) => {
            this.setState({ logs: res.data.data, loadingLogs: false,
                pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingLogs: false });
                displayErrors(err.response.data);
            }
        });
    }

    changePage(data) {
        this.loadLogs(data.current, data.pageSize);
    }

    parseLog(row) {
        let data = [];

        let name = row.actor.first_name;

        if(row.actor.last_name !== null) {
            name += ' ' + row.actor.last_name;
        }

        if(row.actor.user_type === 'API_USER') {
            name += ' (API)'
        }

        data.push(name);
        data.push(row.verb);

        if(row.action_object !== null) {
            if(row.action_object_type === 'domain') {
                data.push(row.action_object.domain);
            } else if(row.action_object_type === 'user') {
                let name = row.action_object.first_name;

                if(row.action_object.last_name!== null) {
                    name += ' ' + row.action_object.last_name;
                }

                data.push(name);
            } else if(row.action_object_type === 'group') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'website_setup_order' || row.action_object_type === 'i_p_address_order' || row.action_object_type === 'shared_hosting_order') {
                data.push('#' + row.action_object.id);
            } else if(row.action_object_type === 'invoice') {
                data.push('#' + row.action_object.id);
            } else if(row.action_object_type === 'payment_method') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'hosting_account') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'shared_hosting_account') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'firewall_rule' || row.action_object_type === 'firewall_ruleset' || row.action_object_type === 'firewall_policy') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'software_preset') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'allocated_i_p') {
                data.push(row.action_object.ip_address);
            } else if(row.action_object_type === 'email_address') {
                data.push(row.action_object.address);
            } else if(row.action_object_type === 'a_p_i_key') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'contact') {
                data.push(row.action_object.first_name + ' ' + row.action_object.last_name);
            } else if(row.action_object_type === 'webhook') {
                data.push(row.action_object.name);
            }
        }

        if(row.action_object_type !== null) {
            if(row.action_object_type === 'software_installation') {
                data.push('(' + row.action_object.name + ')')
            }
        }

        if(row.target !== null) {
            data.push('for');

            if(row.target_type === 'domain') {
                data.push(row.target.domain);
            } else if(row.target_type === 'hosting_account') {
                data.push(row.target.name);
            } else if(row.target_type === 'shared_hosting_account') {
                data.push(row.target.name);
            } else if(row.target_type === 'firewall_rule' || row.target_type === 'firewall_ruleset' || row.target_type === 'firewall_policy') {
                data.push(row.target.name);
            } else if(row.target_type === 'allocated_i_p') {
                data.push(row.target.ip_address);
            }
        }

        return data.join(' ');
    }

    render() {
        const columns = [
            { title: 'Timestamp', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item} /> },
            { title: 'IP Address', dataIndex: 'ip_address' },
            { title: 'Useragent', dataIndex: 'user_agent' },
            { title: 'Action', key: 'action', width: '40%', render: (item, row) => this.parseLog(row)}
        ];

        return(
            <Fragment>
                <Row justify='end'>
                    <Col><Tooltip title='Reload table'><Button type='text' icon={<UndoOutlined/>}
                                                               onClick={() => this.loadLogs()}/></Tooltip></Col>
                </Row>
                <div style={{overflowX: 'auto'}}>
                    <Table
                        columns={columns}
                        rowKey={(item) => item.guid}
                        dataSource={this.state.logs}
                        loading={this.state.loadingLogs}
                        pagination={this.state.pagination}
                        onChange={(e) => this.changePage(e)}
                    />
                </div>
            </Fragment>
    );
    }
    }

    export default connect(null, { updatePage, loadLogs })(Logs);